import PasswordReset from 'app/models/password_reset';
import Base from 'app/views/base';

import { showSuccess, showError } from 'utils/messages';

import tmpl from 'templates/password_reset_request';

export default Base.extend({
  compiledTemplate: tmpl,

  events: {
    'submit #password_reset_form': 'submit',
  },

  initialize() {
    this.model = new PasswordReset({});
  },

  afterRender() {
    this.$('#password_reset_email').focus();
  },

  submit(e) {
    e.preventDefault();

    this.model.save({
      email: this.$('input#password_reset_email').val(),
    }, {
      success() {
        showSuccess('A recovery link has been sent to the given address');
      },
      error() {
        showError('There has been a communication error');
      },
    });
  },
});



// WEBPACK FOOTER //
// ./app/views/password_reset_request_page.js